/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ComponentRef,
  Injectable,
  TemplateRef,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { TemplateSiteComponent } from '@gh/core-ui';
import { IHeaderComp, IHeaderParams } from 'ag-grid-community';
import { GridComponentFactory } from './grid-component-factory';
import { GridHeaderComponent } from './grid-component.interfaces';

@Injectable()
export class GridHeaderComponentFactory implements GridComponentFactory<Type<GridHeaderComponent> | TemplateRef<any>, Type<IHeaderComp>> {

  createComponent(componentType: Type<GridHeaderComponent> | TemplateRef<any>,
                  viewContainerRef: ViewContainerRef): Type<IHeaderComp> {
    if (componentType instanceof TemplateRef) {
      return this.createComponentFromTemplate(componentType, viewContainerRef);
    } else {
      return this.createComponentByFactory(componentType, viewContainerRef);
    }
  }

  createComponentFromTemplate(templateRef: TemplateRef<any>,
                              viewContainerRef: ViewContainerRef): Type<IHeaderComp> {
    class TemplateHeaderComponent implements IHeaderComp {
      private componentRef: ComponentRef<TemplateSiteComponent>;
      private componentInstance: TemplateSiteComponent;

      init(params: any): void {
        this.componentRef = viewContainerRef.createComponent(TemplateSiteComponent);
        this.componentInstance = this.componentRef.instance;

        this.componentInstance.setTemplateRef(templateRef);
        this.attachParameters(params);
      }

      destroy(): void {
        this.componentRef.destroy();
      }

      getGui(): HTMLElement {
        return this.componentRef.location.nativeElement;
      }

      refresh(params: IHeaderParams): boolean {
        this.attachParameters(params);
        return false;
      }

      private attachParameters(params: any): void {
        this.componentInstance.setContext({
          $implicit: params.data,
          colDef: params.colDef,
          column: params.column,
          node: params.node,
        });
      }
    }

    return TemplateHeaderComponent;
  }

  createComponentByFactory(componentType: Type<GridHeaderComponent>,
                           viewContainerRef: ViewContainerRef): Type<IHeaderComp> {
    class HeaderComponentRenderer implements IHeaderComp {
      private componentRef: ComponentRef<GridHeaderComponent>;
      private componentInstance: GridHeaderComponent;

      init(params: any): void {
        this.componentRef = viewContainerRef.createComponent(componentType);
        this.componentInstance = this.componentRef.instance;
        this.componentInstance.agInit(params);
        this.componentRef.changeDetectorRef.detectChanges();
      }

      destroy(): void {
        this.componentRef.destroy();
      }

      getGui(): HTMLElement {
        return this.componentRef.location.nativeElement;
      }

      refresh(params: IHeaderParams): boolean {
        this.componentInstance.agInit(params);
        this.componentRef.changeDetectorRef.detectChanges();
        return false;
      }
    }

    return HeaderComponentRenderer;
  }
}
